import React from "react";

import { LdasCategoryBadge, LdasCountBadge } from "../LdasUtils";

/** lot 상세 화면에서는 certCount·reportCount를 목록 API total과 맞춰 전달하면 카드 숫자가 즉시 동기화됨 */
const LdasDetailProductCard = ({
  product,
  lot,
  certCount: certCountOverride,
  reportCount: reportCountOverride,
}) => {
  const categoryLabel =
    product.categories?.map((c) => c.name).join(", ") ?? "-";

  // console.log("product", product);
  // console.log("lot", lot);

  return (
    <div className="ldas-detail-product-card">
      <div className="ldas-detail-product-card__img-wrap">
        <img
          src={`${process.env.REACT_APP_S3_HOST}/${product.imageUrl}`}
          alt={product.productName}
          className="ldas-detail-product-card__img-wrap"
        />
      </div>
      <div className="ldas-detail-product-card__info">
        <p className="ldas-detail-product-card__brand">{product.brandName}</p>
        <h3 className="ldas-detail-product-card__name">
          {product.productName}
        </h3>
        {product.description && (
          <p className="ldas-detail-product-card__desc">
            {product.description}
          </p>
        )}
        <LdasCategoryBadge label={categoryLabel} />
        {lot && (
          <div className="ldas-detail-lot-meta">
            <div className="ldas-detail-lot-meta__row">
              <span className="ldas-detail-lot-meta__label">로트번호</span>
              <span className="ldas-detail-lot-meta__value ldas-detail-lot-meta__value--mono">
                {lot.lotNumber}
              </span>
            </div>
            <div className="ldas-detail-lot-meta__row">
              <span className="ldas-detail-lot-meta__label">등록일</span>
              <span className="ldas-detail-lot-meta__value">
                {lot.createdAt}
              </span>
            </div>
            <div className="ldas-detail-lot-meta__row">
              <span className="ldas-detail-lot-meta__label">인증 수</span>
              <LdasCountBadge count={certCountOverride ?? lot.certCount} />
            </div>
            <div className="ldas-detail-lot-meta__row">
              <span className="ldas-detail-lot-meta__label">리포트 수</span>
              <LdasCountBadge count={reportCountOverride ?? lot.reportCount} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LdasDetailProductCard;
